import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import makeStyles from "@mui/styles/makeStyles";
import { mapToDisplay } from "../CameraNames";

import VehiclePlaybackVideoPlayer from "./VehiclePlaybackVideoPlayer";
import VehiclePlaybackIframe from "./VehiclePlaybackIframe";
import VehiclePlaybackWebSocketIvms from "./VehiclePlaybackWebSocketIvms";
import VehiclePlaybackWebSocketCmsv6 from "./VehiclePlaybackWebSocketCmsv6";
import VehiclePlaybackNexusWebRtc from "./VehiclePlaybackNexusWebRtc";

const useStyles = makeStyles((theme) => ({
  videoitem: {
    margin: 0,
    position: "relative",
    backgroundColor: "#767676",
    height: "200px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.up("sm")]: {
      height: "100%",
    },
  },
  videoCationLabel: {
    color: "#ffff",
    textAlign: "center",
    marginTop: "10px",
    top: 0,
    left: 0,
    right: 0,
    position: "absolute",
  },
  videoOffLabel: {
    color: "#c5c5c5",
    bottom: "35%",
    width: "100%",
    position: "absolute",
    textAlign: "center",
    fontWeight: "600",
    fontSize: "20px",
  },
}));

const isSupportNexusWebRtc = (footage) => {
  return footage?.node?.streams?.some((x) => x.type === "nexus-webrtc");
};

const isSupportWebSocketIvms = (footage) => {
  return footage?.node?.streams?.some(
    (x) => x.type === "websocket" && x.integrationType === "ivms"
  );
};

const isSupportWebSocketCmsv6 = (footage) => {
  return footage?.node?.streams?.some(
    (x) => x.type === "websocket" && x.integrationType === "cmsv6"
  );
};

const isSupportiFrame = (footage) => {
  return footage?.node?.streams?.some((x) => x.type === "iframe");
};

const VehicleTrackingVideoStream = ({
  isDeviceOnline,
  cameraVideo,
  footageTracking,
  vehicleId,
  playFrom,
}) => {
  const classes = useStyles();
  const [camerasTracking, setCamerasTracking] = useState([]);
  const [playing, setPlaying] = useState({});

  const handlePlayClick = (idx) => {
    setPlaying((prev) => ({ ...prev, [idx]: true }));
  };

  const handlePauseClick = (idx) => {
    setPlaying((prev) => ({ ...prev, [idx]: false }));
  };

  useEffect(() => {
    if (footageTracking && cameraVideo) {
      const cameraVideosMap = cameraVideo.map((item) => ({
        ...item,
        footages: footageTracking.filter(
          (x) => x.node.cameraId === item.cameraId
        ),
      }));
      setCamerasTracking(cameraVideosMap);
    }
  }, [footageTracking, cameraVideo]);

  return (
    <>
      {cameraVideo.map((video, idx) => {
        const footage = camerasTracking?.[idx]?.footages?.[0];

        return (
          <div className={classes.videoitem} key={`video-${idx}`}>
            {footage &&
              (isSupportNexusWebRtc(footage) ? (
                <VehiclePlaybackNexusWebRtc
                  vehicleId={vehicleId}
                  cameraId={footage.node?.cameraId}
                  playFrom={playFrom}
                  play={playing[idx]}
                  onPlayClick={() => handlePlayClick(idx)}
                  onPauseClick={() => handlePauseClick(idx)}
                />
              ) : isSupportWebSocketIvms(footage) ? (
                <VehiclePlaybackWebSocketIvms
                  sources={footage.node?.streams}
                  play={playing[idx]}
                  onPlayClick={() => handlePlayClick(idx)}
                  onPauseClick={() => handlePauseClick(idx)}
                />
              ) : isSupportWebSocketCmsv6(footage) ? (
                <VehiclePlaybackWebSocketCmsv6
                  idx={idx}
                  label={video.camera}
                  sources={footage.node?.streams}
                  play={playing[idx]}
                  onPlayClick={() => handlePlayClick(idx)}
                  onPauseClick={() => handlePauseClick(idx)}
                />
              ) : isSupportiFrame(footage) ? (
                <VehiclePlaybackIframe sources={footage.node?.streams} />
              ) : (
                <VehiclePlaybackVideoPlayer
                  sources={footage.node?.streams}
                  play={playing[idx]}
                  onPlayClick={() => handlePlayClick(idx)}
                  onPauseClick={() => handlePauseClick(idx)}
                />
              ))}

            <div className={classes.videoCationLabel}>
              {mapToDisplay(video.camera)}
            </div>

            {!isDeviceOnline && (
              <div className={classes.videoOffLabel}>Vehicle is offline</div>
            )}

            {isDeviceOnline && !footage && (
              <div className={classes.videoOffLabel}>Not found footage</div>
            )}
          </div>
        );
      })}
    </>
  );
};

VehicleTrackingVideoStream.propTypes = {
  cameraVideo: PropTypes.array.isRequired,
  footageTracking: PropTypes.array,
  isDeviceOnline: PropTypes.bool,
  vehicleId: PropTypes.string,
  playFrom: PropTypes.string,
};

export default VehicleTrackingVideoStream;
